module.exports = __webpack_public_path__ + "img/2_no.aa21bf68.svg";